"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionTypeToJSON = exports.TransactionTypeFromJSONTyped = exports.TransactionTypeFromJSON = exports.TransactionType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var TransactionType;
(function (TransactionType) {
    TransactionType["ScoreEntry"] = "ScoreEntry";
    TransactionType["CloseScoring"] = "CloseScoring";
    TransactionType["ReopenScoring"] = "ReopenScoring";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
function TransactionTypeFromJSON(json) {
    return TransactionTypeFromJSONTyped(json, false);
}
exports.TransactionTypeFromJSON = TransactionTypeFromJSON;
function TransactionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TransactionTypeFromJSONTyped = TransactionTypeFromJSONTyped;
function TransactionTypeToJSON(value) {
    return value;
}
exports.TransactionTypeToJSON = TransactionTypeToJSON;
